import React from 'react';
import ConfirmationDialog from '@au/core/lib/components/objects/ConfirmationDialog';
import styles from '../css/components/sync_rule_detail_dialog.module.scss';

const SyncResultDetailsDialog = ({ details, titleId, onClose }) => {
  return (
    <ConfirmationDialog
      headerClassName={styles.header}
      bodyClassName={styles.body}
      titleId={titleId || 'au.entity.attr.syncResultDetails'}
      confirmDisplayId={'au.entity.close'}
      showCancelButton={false}
      onConfirm={onClose}
      onCancel={onClose}
    >
      <div className={styles.subheader}>
        <div className={styles.subheader_item}>
          <span className={styles.subheader_title}>Environment:</span>
          <span className={styles.subheader_value}>{details?.environment}</span>
        </div>

        <div className={styles.subheader_item}>
          <span className={styles.subheader_title}>Release Stage Name:</span>
          <span className={styles.subheader_value}>{details?.releaseStageName}</span>
        </div>

        <div className={styles.subheader_item}>
          <span className={styles.subheader_title}>Live Id:</span>
          <span className={styles.subheader_value}>{details?.liveId}</span>
        </div>

        <div className={styles.subheader_item}>
          <span className={styles.subheader_title}>History Id:</span>
          <span className={styles.subheader_value}>{details?.historyId}</span>
        </div>

        <div className={styles.subheader_item}>
          <span className={styles.subheader_title}>Last Sync Result:</span>
          <span className={styles.subheader_value}>{details?.lastSyncResult}</span>
        </div>

        {details?.lastAuditId && (
          <div className={styles.subheader_item}>
            <span className={styles.subheader_title}>Last Audit Id:</span>
            <span className={styles.subheader_value}>{details?.lastAuditId}</span>
          </div>
        )}
      </div>
    </ConfirmationDialog>
  );
};

export default SyncResultDetailsDialog;
